const AgGridPagination = require('../../v4/components/ag_grid_pagination');

const Visitors = {
  selector() {
    return '#all-visitors-grid';
  },
  element() {
    return $(this.selector());
  },
  visitor() {
    return this.element().data('visitor');
  },
  spinner() {
    return this.element().parent().find('.spinner');
  },

  _gridApi: null,

  _gridOptions: {
    rowData: null,
    headerHeight: 44,
    rowHeight: 44,
    defaultColDef: {
      sortable: true,
      resizable: true
    },
    onGridReady(_event) {
      return _event.api.sizeColumnsToFit();
    },
    onGridSizeChanged(_event) {
      return _event.api.sizeColumnsToFit();
    },
    pagination: true,
    suppressPaginationPanel: true,
    paginationPageSize: 12,
    cacheOverflowSize: 1,
    columnDefs: [
      {
        field: 'company_name',
        cellRenderer(params) {
          return Visitors.companyNameRenderer(params);
        },
        headerName: I18n.t('dashboards.profile.visitors_table.company_name'),
        width: 275
      },
      {
        field: 'company_category',
        headerName: I18n.t('dashboards.profile.visitors_table.company_type')
      },
      {
        field: 'title',
        headerName: I18n.t('dashboards.profile.visitors_table.title')
      },
      {
        field: 'name',
        cellRenderer(params) {
          return Visitors.nameRenderer(params);
        },
        headerName: I18n.t('dashboards.profile.visitors_table.user_name'),
        width: 275
      },
      {
        field: 'views_count',
        headerName: I18n.t('dashboards.profile.visitors_table.no_of_views'),
        width: 160
      },
      {
        field: 'first_view',
        comparator() {
          return Visitors.dateComparator(valueA, valueB, nodeA, nodeB, 'first_view_unix');
        },
        headerName: I18n.t('dashboards.profile.visitors_table.first_visit')
      },
      {
        field: 'last_view',
        comparator() {
          return Visitors.dateComparator(valueA, valueB, nodeA, nodeB, 'last_view_unix');
        },
        headerName: I18n.t('dashboards.profile.visitors_table.last_visit')
      },
      {
        field: 'breakdown_url',
        cellRenderer(params) {
          return Visitors.breakdownUrlRenderer(params);
        },
        headerName: I18n.t('dashboards.profile.visitors_table.breakdown')
      }
    ],
  },

  companyNameRenderer(params) {
    return `<a target='_blank' href='${params.data.company_url}'>${params.data.company_name}</a>`;
  },

  nameRenderer(params) {
    return `<a data-remote='true' href='${params.data.url}'>${params.data.name}</a>`;
  },

  breakdownUrlRenderer(params) {
    return `<div id='breakdownUrl' data-url='${params.data.breakdown_url}' data-name='${params.data.company_name}'>
      <i class='pti pt-pie-chart'></i>
      <span>${I18n.t('dashboards.profile.visitors_table.details')}</span>
    </div>`;
  },

  dateComparator(valueA, valueB, nodeA, nodeB, field) {
    return nodeA.data[field] - nodeB.data[field];
  },

  initializeGrid() {
    this._gridApi = agGrid.createGrid(this.element()[0], this._gridOptions);
    this._gridOptions.api = this._gridApi;
    return this;
  },

  initializeGridPagination() {
    var agGridPagination = AgGridPagination.initialize(this._gridOptions);
    return this._gridOptions.onPaginationChanged = agGridPagination.renderPagination.bind(agGridPagination);
  },

  defaultSort: [
    {
      colId: 'views_count',
      sort: 'desc'
    }
  ],

  reload(data) {
    this.initializeGridPagination();
    AgGridPagination.initializePaginationListeners();
    this._gridApi.setColumnVisible('breakdown_url', _.isEmpty(this.visitor()));
    this._gridApi.setColumnVisible('company_name', _.isEmpty(this.visitor()));
    this._gridApi.setGridOption('rowData', data);
    this._gridApi.sizeColumnsToFit();
    resizeAgGridTable(this.element(), this._gridOptions, 0, Math.min(this._gridOptions.paginationPageSize, data.length));
    this.spinner().hide();
    return this._gridApi.applyColumnState({ state: this.defaultSort, defaultState: { sort: null } });
  },

  clearTable() {
    this._gridApi.setGridOption('rowData', null);
    resizeAgGridTable(this.element(), this._gridOptions, 0, 0);
    this.spinner().show();
  },
};

module.exports = Visitors;
